import { type EuroCents, type MandantID } from '../../types/branded';
export type { MandantID };

// ── Rechnungs-Typen ────────────────────────────────────────────────────────

export type RechnungsStatus = 'entwurf' | 'gestellt' | 'bezahlt' | 'gemahnt' | 'storniert';

export interface RechnungsPosition {
  leistungCode:   string;
  bezeichnung:    string;
  menge:          number;
  einheit:        string;
  einzelpreisNetto: EuroCents;
  ustSatz:        0 | 10 | 20;
  gesamtNetto:    EuroCents;
  gesamtUst:      EuroCents;
  gesamtBrutto:   EuroCents;
}

export interface Rechnungsadresse {
  firma:       string;
  strasse:     string;
  plz:         string;
  ort:         string;
  land:        string;
  uid?:        string | undefined;   // UID-Nummer (§11 UStG)
  kundennr?:   string | undefined;
}

export interface Rechnung {
  id?:           number;
  mandantId:     MandantID;
  rechnungsNr:   string;             // z.B. "2025-001"
  datum:         string;             // ISO-Date
  faelligAm:     string;             // ISO-Date (Standard: +30 Tage)
  empfaenger:    Rechnungsadresse;
  positionen:    RechnungsPosition[];
  summeNetto:    EuroCents;
  summeUst:      EuroCents;
  summeBrutto:   EuroCents;
  status:        RechnungsStatus;
  zahlungsbedingungen: string;
  leistungszeitraum?:  string | undefined;
  anmerkungen?:        string | undefined;
  erstelltAm:    string;
}

// ── Aussteller (§11 UStG Pflichtangaben) ─────────────────────────────────

export interface Aussteller {
  name:           string;
  titelVor?:      string | undefined;
  titelNach?:     string | undefined;
  strasse:        string;
  plz:            string;
  ort:            string;
  land:           string;
  uid:            string;            // UID Pflicht §11 (1) Z 3 UStG
  steuernummer?:  string | undefined;
  iban:           string;
  bic:            string;
  bank:           string;
  telefon?:       string | undefined;
  email?:         string | undefined;
  web?:           string | undefined;
}

// Standard-Aussteller (Dr. Karrer)
export const AUSSTELLER_DEFAULT: Aussteller = {
  name:        'Klaus Karrer',
  titelVor:    'Dr. med.',
  titelNach:   'MSc.',
  strasse:     'Musterstraße 1',
  plz:         '8990',
  ort:         'Bad Aussee',
  land:        'AT',
  uid:         'ATU99999999',
  iban:        'AT12 3456 7890 1234 5678',
  bic:         'BKAUATWW',
  bank:        'Bank Austria',
  email:       'mail@dr-karrer.com',
};
